export default {
    required: [v => !!v || '*'],
};